<div class="area-qty-wrapper w-100" style="min-width: 0; position: relative;">

  <!-- Non-area: plain passthrough -->
  <input *ngIf="!isAreaUom"
    type="number"
    [class]="cssClass"
    style="flex: 1 1 auto; min-width: 0; align-self: stretch;"
    [(ngModel)]="value"
    (ngModelChange)="onDirectChange()"
    min="0"
    step="0.001"
  />

  <!-- Area — always show the main input with L×W toggle button -->
  <ng-container *ngIf="isAreaUom">
    <div class="d-flex align-items-stretch w-100">
      <input
        type="number"
        [class]="cssClass"
        style="flex: 1 1 auto; min-width: 0;"
        [(ngModel)]="value"
        (ngModelChange)="onDirectChange()"
        [readOnly]="mode === 'calculate'"
        min="0"
        step="0.001"
        [placeholder]="mode === 'calculate' ? (value | number:'1.0-2') + ' ' + displayUomCode : 'Surface area'"
      />
      <button
        type="button"
        class="btn btn-sm px-2 text-nowrap area-toggle align-self-center ms-1"
        [class.btn-primary]="mode === 'calculate'"
        [class.btn-outline-secondary]="mode === 'direct'"
        title="Calculate from Length × Width"
        (click)="setMode(mode === 'direct' ? 'calculate' : 'direct')"
      >L×W</button>
    </div>

    <!-- Calculator dropdown — shown below when in calculate mode -->
    <div *ngIf="mode === 'calculate'"
      class="area-calc-panel border rounded bg-white p-2 mt-1 d-flex align-items-center gap-2"
      style="position: absolute; z-index: 100; left: 0; right: 0; box-shadow: 0 2px 8px rgba(0,0,0,0.12);">
      <div class="d-flex flex-column" style="flex: 1;">
        <small class="text-muted" style="font-size: 0.65rem;">Length (mm)</small>
        <input type="number" class="form-control form-control-sm"
          [(ngModel)]="lengthMm" (ngModelChange)="onDimensionsChange()"
          placeholder="0" min="0" step="0.1" />
      </div>
      <span class="text-muted fw-semibold mt-3">×</span>
      <div class="d-flex flex-column" style="flex: 1;">
        <small class="text-muted" style="font-size: 0.65rem;">Width (mm)</small>
        <input type="number" class="form-control form-control-sm"
          [(ngModel)]="widthMm" (ngModelChange)="onDimensionsChange()"
          placeholder="0" min="0" step="0.1" />
      </div>
      <span class="text-muted text-nowrap mt-3" style="font-size: 0.8rem;">
        = {{ value | number:'1.0-2' }} {{ displayUomCode }}
      </span>
    </div>
  </ng-container>

</div>
